import { LoadableAccountSettings } from '.';

export default {
  path: 'accounts/:id/settings/:type?/:subType?',
  name: 'Account Settings',
  childRoutes: [
    { path: 'account-settings', name: 'Account settings', component: LoadableAccountSettings, isIndex: true },
  ],
};
